<template>
  <PageForm
    class="form-vacancies"
    action="feedbackVacancies"
    :form-config="formConfig"
    :extra-field-names="['vacancyId']"
    :submit-label="submitLabel"
  >
    <template #header-actions>
      <a v-if="btnLink" :href="btnLink" target="_blank" class="form-vacancies__hh-link t-btn _border _big">
        {{ btnLeft }}
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 24C18.624 24 24 18.624 24 12C24 5.376 18.624 0 12 0C5.376 0 0 5.376 0 12C0 18.624 5.376 24 12 24ZM6.708 6.348V10.428C7.332 9.684 8.076 9.312 8.94 9.312C9.384 9.312 9.78 9.39599 10.14 9.56399C10.5 9.73199 10.764 9.948 10.944 10.212C11.124 10.476 11.244 10.764 11.316 11.088C11.388 11.4 11.412 11.892 11.412 12.564V16.932H9.48V12.996C9.48 12.216 9.444 11.724 9.372 11.508C9.3 11.292 9.168 11.136 8.988 11.004C8.808 10.884 8.568 10.812 8.292 10.812C7.968 10.812 7.68 10.896 7.44 11.052C7.188 11.208 6.996 11.448 6.888 11.772C6.768 12.096 6.708 12.564 6.708 13.188V16.92H4.776V6.348H6.708ZM14.316 6.348V10.428C14.94 9.684 15.684 9.312 16.548 9.312C16.992 9.312 17.388 9.39599 17.748 9.56399C18.108 9.73199 18.372 9.948 18.552 10.212C18.732 10.476 18.852 10.764 18.924 11.088C18.996 11.4 19.02 11.892 19.02 12.564V16.932H17.088V12.996C17.088 12.216 17.052 11.724 16.98 11.508C16.908 11.292 16.776 11.136 16.596 11.004C16.416 10.884 16.176 10.812 15.9 10.812C15.576 10.812 15.288 10.896 15.048 11.052C14.796 11.208 14.616 11.448 14.496 11.772C14.376 12.096 14.316 12.564 14.316 13.188V16.92H12.384V6.348H14.316Z"
            fill="currentColor"
          />
        </svg>
      </a>
    </template>
  </PageForm>
</template>

<script>
import PageForm from '@shared/ui/public/forms/PageForm.vue'
import { LEGACY_FORM_VARIANTS } from '@shared/const/form/form.data'
import { FORM_FIELD_MAX_SPAN, FORM_FIELD_TYPE, FORM_FIELD_VIEW } from '@shared/const/form/form.field'

export default {
  name: 'form-vacancies',
  components: {
    PageForm,
  },
  props: {
    title: String,
    description: String,
    vacancyId: String,
    btnLeft: String,
    btnLink: String,
    submitLabel: String,
  },
  data() {
    return {
      infoForm: {
        action: 'feedbackVacancies',
        disabledForm: false,
        isPersonalData: false,
        errorPersonalData: false,
        success: false,
        error: false,
      },
    }
  },
  computed: {
    formConfig() {
      return {
        title: this.title,
        description: this.description,
        type: LEGACY_FORM_VARIANTS.DEFAULT_BUILDER,
        vacancyId: this.vacancyId,
        fields: [
          {
            content: {
              title: this.$root.staticText.forms.name,
              name: 'name',
              typeField: FORM_FIELD_TYPE.STRING,
              type: FORM_FIELD_VIEW.TEXT,
              hintField: this.$root.staticText.forms.placeholderName,
              requiredField: true,
            },
          },
          {
            content: {
              title: this.$root.staticText.forms.surname,
              name: 'surname',
              typeField: FORM_FIELD_TYPE.STRING,
              type: FORM_FIELD_VIEW.TEXT,
              hintField: this.$root.staticText.forms.placeholderSurname,
              requiredField: true,
            },
          },
          {
            content: {
              title: this.$root.staticText.forms.email,
              name: 'email',
              typeField: FORM_FIELD_TYPE.EMAIL,
              type: FORM_FIELD_VIEW.TEXT,
              hintField: this.$root.staticText.forms.placeholderEmail,
              requiredField: true,
            },
          },
          {
            content: {
              title: this.$root.staticText.forms.phone,
              name: 'phone',
              typeField: FORM_FIELD_TYPE.PHONE,
              type: FORM_FIELD_VIEW.PHONE,
              hintField: '+7',
              requiredField: true,
            },
          },
          {
            content: {
              title: '',
              name: 'files[]',
              width: FORM_FIELD_MAX_SPAN,
              typeField: FORM_FIELD_TYPE.FILE,
              type: FORM_FIELD_VIEW.DROPZONE,
              hintField: this.$root.staticText.forms.placeholderDropzone,
              requiredField: false,
            },
          },
        ],
      }
    },
  },
}
</script>

<style lang="sass">
.form-vacancies
  .t-btn.form-vacancies__hh-link
    display: flex
    align-items: center
    justify-content: center
    gap: 8px
    padding: 10px 38px 12px
</style>



// WEBPACK FOOTER //
// src/templates/components/base/forms/form-vacancies.vue